import ApiGenerator from '@services/ApiGenerator';

const GET = 'osba/account/TopicOfInterests_INFO_GET';
const GET_ERROR = 'osba/account/TopicOfInterests_INFO_GET_ERROR';
const GET_RECEIVED = 'osba/account/TopicOfInterests_INFO_GET_RECEIVED';
const SAVE = 'osba/account/TopicOfInterests_INFO_SAVE';
const SAVE_ERROR = 'osba/account/TopicOfInterests_INFO_SAVE_ERROR';
const SAVE_RECEIVED = 'osba/account/TopicOfInterests_INFO_SAVE_RECEIVED';

const initialState = {
  SelectedTopicOfInterests: [],
  loading: false,
  message: '',
  error: '',
};

const mapResponse = (data) => {
  const flattenedTopicOfInterests = data.SelectedTopicOfInterests.map(item => item.Name);

  return ({
    message: data.Message,
    SelectedTopicOfInterests: flattenedTopicOfInterests,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case SAVE:
      return {
        ...state,
        ...action.data,
        loading: true,
        error: '',
      };
    case GET_RECEIVED:
    case SAVE_RECEIVED:
      return {
        ...state,
        ...mapResponse(action.data),
        loading: false,
      };
    case GET_ERROR:
    case SAVE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export const getSelectedTopicOfInterests = () => ({
  type: GET,
});

export const saveSelectedTopicOfInterests = data => ({
  type: SAVE,
  data: {
    SelectedTopicOfInterests: data.SelectedTopicOfInterests,
  },
});

export const middleware = () => next => (action) => {
  const api = ApiGenerator(next);

  next(action);

  switch (action.type) {
    case GET:
      api('get', '/TopicOfInterestBlock/GetTopicOfInterestsSubscriptions', GET);
      break;
    case SAVE:
      api('post', '/TopicOfInterestBlock/SaveTopicOfInterestsSubscriptions', SAVE, {
        ...action.data,
      });
      break;
    default:
      break;
  }
};

export default reducer;
